export default "__VITE_ASSET__Bhm2Tq4a__"